import { render, staticRenderFns } from "./DistributionDifference.vue?vue&type=template&id=47ccb192&scoped=true"
import script from "./DistributionDifference.vue?vue&type=script&lang=js"
export * from "./DistributionDifference.vue?vue&type=script&lang=js"
import style1 from "./DistributionDifference.vue?vue&type=style&index=1&id=47ccb192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccb192",
  null
  
)

export default component.exports